import Tracker from '@openreplay/tracker';
import { v4 as uuidV4 } from 'uuid';

function defaultGetUserId() {
  return uuidV4();
}

export function startTracker(config, userId = null, axios) {
  const getUserId = (config?.userIdEnabled && config?.getUserId) ? config.getUserId : defaultGetUserId;
  let localUserId = null;

  // userIdが提供された場合にsetUserIDを呼び、優先的に設定
  if (userId) {
    localUserId = userId;
  } else if (config?.userIdEnabled) {
    localUserId = getUserId();
  }

  const trackerConfig = {
    projectKey: config.projectKey,
    __DISABLE_SECURE_MODE: location.hostname === 'localhost' || location.hostname === '127.0.0.1',
    longTasks: true,
    network: {
      failuresOnly: false,
      capturePayload: true,
      axiosInstances: [axios]
    }
  };

  const tracker = new Tracker(trackerConfig);

  // start()前にsetUserIDを呼ぶ
  if (localUserId) {
    tracker.setUserID(localUserId);
  }

  // プラグインのセットアップ
  const pluginReturns = {};
  if (config?.plugins) {
    Object.entries(config.plugins).forEach(([name, plugin]) => {
      if (typeof plugin === 'function') {
        pluginReturns[name] = plugin(tracker);
      }
    });
  }

  tracker.start();
  return {
    tracker,
    userId: localUserId,
    ...pluginReturns
  };
}